import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const trackPageView = (): void => {
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'PageView');
  }
};

const MetaPixelPageView: React.FC = () => {
  const location = useLocation();
  const isInitialLoad = useRef(true);

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      return;
    }

    trackPageView();
  }, [location.pathname]);

  return null;
};

export default MetaPixelPageView;
